module.exports = __webpack_public_path__ + "static/media/settings-gear_1.73abb111.svg";